import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Footer from '../../component/common/footer';
import SEO from '../../component/util/SEO';
import "./price.css"
function Pricing() {
  const { t } = useTranslation();
  let nightMode = useSelector(state => state.NightMode);
  const pricingPlans = [
    {
      name: 'Maintenance',
      description: 'A package for enhancing and maintaining existing applications.',
      features: ['Small projects', 'Custom scripts', 'Website fixes', 'Hosting support'],
      price: 'GBP100 - GBP1000',
    },
    {
      name: 'Designing',
      description: 'A monthly design subscription package for brand and campaign assets.',
      features: ['Logos and branding', 'Landing pages', 'Email templates', 'Social media graphics'],
      price: 'GBP500 - GBP1500',
    },
    {
      name: 'Portfolio',
      description: 'An online presence package for small businesses and founders.',
      features: ['Five-page website', 'Responsive user-friendly interface', 'Essential website functionality', 'Basic SEO optimization'],
      price: 'GBP1000 - GBP3000',
    },
    {
      name: 'SaaS',
      description: 'A complete web-based service design and development solution.',
      features: ['System and interface design', 'Service development', 'Hosting setup', 'One month of maintenance'],
      price: 'GBP3000+',
    },
  ];

  return (
    <>
      <main className={nightMode ? "night-theme" : "day-theme"}>
        <SEO
          title="Website and Software Pricing"
          description="Review BringIt Go pricing ranges for maintenance, design subscriptions, portfolio websites, SaaS applications, hosting, and custom software projects."
          canonical="https://www.bringitgo.tech/pricing"
          keywords="website pricing UK, software development pricing, SaaS development cost, web design pricing"
        />
        <section className="pricing" id="pricing" aria-labelledby="pricing-heading">
        <div style={{ width: "91.5vw", margin: "auto" }}>
          <Row>
            <Col>
              <h1 id="pricing-heading" className="pricing-heading">{t("price")}</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className='pricing-description'>{t("priceDescription")}</p>
            </Col>
          </Row>
        </div>
        <div className='pricing-container pb-4'>
          <Row>
            <h2 className='project-heading mt-4'>{t("pricePlans")}</h2>
          </Row>
          <Row as="ul" className="pricing-plan-list" xl={4} lg={3} md={2} sm={2}>
            {pricingPlans.map((plan) => (
              <Col as="li" key={plan.name}>
                <article className={`price-container-background ${nightMode ? "bg-dark" : "price-bg"}`}>
                  <h3 className='pricing-package-heading'>{plan.name}</h3>
                  <div className='package-feature'>
                    <p className='mx-3'>{plan.description}</p>
                    <ul>
                      {plan.features.map((feature) => (
                        <li key={feature}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                  <p className='prices'>{plan.price}</p>
                </article>
              </Col>
            ))}
          </Row>
        </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default Pricing
